import React, { useState, useEffect } from 'react';

import styles from './monitorizations.module.scss';

import CModal from '../../components/modal/modal';
import CButton from '../../components/button/button';
import CCard from '../../components/card/card';
import CSearchBar from '../../components/search-bar/search_bar';
import CSorting from '../../components/sort/sort';
import { Space } from '../../components/utils/utils';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../routing/routes';
import { getAll } from '../../network/monitorization';
import { buildMonitorizationMessage, prettyDate } from '../../utils/strings';
import { IMonitorization } from '../../utils/interfaces/interfaces';
import { sort_chronologically } from '../../utils/lists';
import AddMonitorization from './add_monitorization';
import { Skeleton } from 'antd';

const Decisions = () => {
  const [loading, setLoading] = useState(false);
  const [openedModal, setModal] = useState(false);
  const [filterValue, setValue] = useState('');
  const [sortValue, setSort] = useState('');
  const [decisions, setDecisions] = useState<IMonitorization[] | []>([]);
  const [initialList, setInitial] = useState<IMonitorization[] | []>([]);

  const getDecisions = () => {
    setLoading(true);
    getAll().then(({ data }) => {
      data.data && setDecisions(data.data);
      data.data && setInitial(data.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    getDecisions();
  }, []);

  const addNew = () => {
    setModal(!openedModal);
  };

  const handleFilter = (event: React.ChangeEvent<any>) => {
    const { value } = event.target;
    setValue(value);
  };

  const handleSort = (key: string) => {
    setSort(key);
  };

  useEffect(() => {
    const direction = sortValue === 'up' ? 1 : -1;
    const sorted = sort_chronologically(initialList, 'createdAt', direction);

    setDecisions([...sorted]);
  }, [sortValue, initialList]);

  useEffect(() => {
    const filtered = initialList.filter(
      (option: IMonitorization) =>
        `Monitorizarea ${option.name} cu numărul ${
          option.number
        } creată pe ${prettyDate(option.createdAt)}`
          .toLowerCase()
          .includes(filterValue) ||
        prettyDate(option.date).toLowerCase().includes(filterValue)
    );

    setDecisions(filtered);
  }, [filterValue, initialList]);

  return (
    <div className={styles.container}>
      <CModal opened={openedModal} openModal={setModal}>
        <AddMonitorization
          callback={() => {
            getDecisions();
            setModal(false);
          }}
        />
      </CModal>
      <div className={styles.rowInfo}>
        <div className='column align-start fullWidth'>
          <p className='subheading-dark bold'>Gestionare monitorizari</p>
          <p className='body-dark'>
            Ați început {initialList.length}{' '}
            {initialList.length === 1 ? 'monitorizare' : 'monitorizari'}.
          </p>
        </div>
        <Space vertical={10} />
        <CButton
          type='button'
          label='Crează monitorizare nouă'
          onClick={addNew}
        />
      </div>
      <div className={styles.content}>
        <div className='justify-start wrap'>
          <CSearchBar value={filterValue} onChange={handleFilter} />
          <Space horizontal={20} />
          <CSorting value={filterValue} onChange={handleSort} />
        </div>
        {loading && <Skeleton active />}

        {decisions && (
          <div className={styles.list}>
            {decisions.length > 0 &&
              decisions.map((option: IMonitorization) => (
                <CCard
                  key={option.id}
                  title={`Monitorizarea ${option.name} cu numărul ${
                    option.number
                  } creată pe ${prettyDate(option.createdAt)}`}
                  description={buildMonitorizationMessage(
                    option.type,
                    option.fileCount,
                    option.measureCount,
                    option.expiredMeasureCount,
                    option.expiredMeasureCountToday
                  )}
                  details={
                    <Link
                      to={{
                        pathname: ROUTES.DECISION,
                        state: {
                          id: option.id,
                          editingMode: true
                        }
                      }}
                    >
                      Detalii
                    </Link>
                  }
                />
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Decisions;
